import { makeStyles } from "tss-react/mui";
import ColourConstants from "helpers/colourConstants";

const ROW_DIVIDER_COLOUR = "rgba(224, 224, 224, 1)";
// The checkbox itself renders left-aligned within its cell (there's no
// flex/justify-content centering it), so symmetric padding only happens when
// the cell is exactly wide enough that the trailing space matches the
// leading padding: 10px (the app-wide .MuiTableCell-root override) either
// side of the ~38px Checkbox touch-target root = 58px. MUI's own
// padding="checkbox" default of 48px is 10px too narrow for that, which is
// what left the right padding looking squeezed under table-layout: fixed.
export const SELECTION_COLUMN_WIDTH_PX = 58;

const useModelTaskTableStyles = makeStyles()(() => ({
	table: {
		borderStyle: "solid",
		borderColor: ColourConstants.tableBorder,
		borderWidth: 1,
		borderRadius: 0,
		fontFamily: "Roboto Condensed",
		fontSize: 14,
		overflowX: "auto",
		// Column widths come from useAutoColumnWidths and are set on the header
		// row. Fixed layout means only that (never-virtualised) row's widths
		// drive column sizing, so recycling rows during scroll can't perturb
		// them - auto layout was recalculating widths from whichever rows the
		// virtualiser happened to have mounted, causing a mid-scroll flicker.
		tableLayout: "fixed",
	},
	tableHeadRow: {
		borderBottomColor: ColourConstants.tableBorder,
		borderBottomStyle: "solid",
		borderBottomWidth: 1,
		backgroundColor: ColourConstants.tableBackground,
		fontWeight: "bold",
		borderRightColor: "#979797",
		borderRightStyle: "solid",
		borderRightWidth: "1px",
	},
	selectedTableHeadRow: {
		borderBottomColor: ColourConstants.tableBorder,
		borderBottomStyle: "solid",
		borderBottomWidth: 1,
		backgroundColor: ColourConstants.tableBackgroundSelected,
		color: "#FFFFFF",
		fontWeight: "bold",
	},
	// Actual header widths come exclusively from useAutoColumnWidths, set as
	// an inline style in ModelTaskHeader.js - no width here.
	nameRow: { height: "10px", lineHeight: "1rem" },
	dataCell: { height: 40 },
	selectionCell: { width: SELECTION_COLUMN_WIDTH_PX },
	statusCell: { padding: 12, textAlign: "center" },
	// Drawn as a shadow, not a border: the expanded row collapses to zero height,
	// so its `border-bottom: hidden` wins the border-collapse conflict and erases
	// any real border on the adjoining edge.
	rowDivider: { boxShadow: `inset 0 -1px 0 ${ROW_DIVIDER_COLOUR}` },
	// One treatment for every full-width action row: Go to Top, Load previous,
	// and the retry rows. They all read as the same affordance.
	tableAction: {
		cursor: "pointer",
		color: ColourConstants.activeLink,
		fontFamily: "Roboto Condensed",
		fontWeight: "bold",
		fontSize: 15,
		textAlign: "center",
		verticalAlign: "middle",
		"&:hover": { backgroundColor: ColourConstants.hoverGrey },
	},
	// Same row, nothing to click yet.
	tableActionBusy: {
		color: ColourConstants.commonText,
		fontFamily: "Roboto Condensed",
		fontSize: 15,
		textAlign: "center",
		verticalAlign: "middle",
	},
}));

export default useModelTaskTableStyles;
